export function parseMessageData(messageData: any) {
  if (typeof messageData !== 'object') { return null }
  const type = messageData.type
  const data = messageData.data

  if (type !== 'navigate' || typeof data !== 'string') { return null }

  return {type, data}
}